// NotificationService.ts
import { useToast } from 'vue-toastification';

// Función para obtener la instancia de toast
function getToast() {
  try {
    return useToast();
  } catch {
    // Fallback silencioso si toast no está disponible
    return {
      success: () => {},
      info: () => {},
      warning: () => {},
      error: () => {},
    };
  }
}

const toast = getToast();

const notify = {
  loginSuccess() {
    toast.success('Has iniciado sesión exitosamente.');
  },
  logoutSuccess() {
    toast.info('Has cerrado sesión.');
  },
  ticketCreated() {
    toast.success('Ticket creado correctamente.');
  },
  ticketUpdated() {
    toast.info('Ticket actualizado.');
  },
  chatSent() {
    toast.success('Mensaje enviado en chat.');
  },
  error(msg = 'Ha ocurrido un error.') {
    toast.error(msg);
  },
  validationError(msg = 'Por favor, revise los campos del formulario.') {
    toast.error(`Error de validación: ${msg}`);
  },
  formCancelled() {
    toast.info('Operación cancelada.');
  },
  unsavedChanges() {
    toast.warning('Hay cambios sin guardar. ¿Está seguro de continuar?');
  },
  // Métodos adicionales para compatibilidad con WebSocket
  success(msg: string) {
    toast.success(msg);
  },
  info(msg: string) {
    toast.info(msg);
  },
  warning(msg: string) {
    toast.warning(msg);
  }
};

// Composable para compatibilidad con WebSocket
export function useNotificationService() {
  return {
    success: (msg: string) => notify.success(msg),
    info: (msg: string) => notify.info(msg),
    warning: (msg: string) => notify.warning(msg),
    error: (msg: string) => notify.error(msg)
  };
}

export default notify;

